/* eslint-disable max-len */
import React from 'react';
import './style.scss';

const SubscribeMailingList = () => (
    <div
        className="subscribe-mailing-list-container"
    >
        <div className="pattern-background-gradient-overlay is-theme-info" />
        <span className="icon is-primary title-icon has-text-white">
            <i className="fas fa-envelope" />
        </span>
        <div className="title is-size-4-touch is-size-3-desktop is-spaced has-text-white">Subscribe for regular updates</div>
        <div className="subtitle is-size-5-touch is-size-4-desktop has-text-white">
            Receive updates on new products and our regular CBD related blog posts.
        </div>


        <form
            id="mc-embedded-subscribe-form"
            className="validate"
            action="https://maverixx.us20.list-manage.com/subscribe/post?u=3a0038d21a717327aa3a61f27&amp;id=926f8982eb"
            method="post"
            name="mc-embedded-subscribe-form"
            target="_blank"
        >
            <div className="field has-addons subscribe-form">
                <div className="control">
                    <input
                        id="mce-EMAIL"
                        name="EMAIL"
                        className="input is-large required email"
                        type="email"
                        placeholder="Your email address"
                    />
                </div>
                <div className="control">
                    <input
                        hidden
                        checked
                        type="checkbox"
                        id="gdpr_22049"
                        name="gdpr[22049]"
                        value="Y"
                        className="av-checkbox "
                    />
                    <button
                        id="mc-embedded-subscribe"
                        type="submit"
                        className="button is-large is-theme-success has-text-white has-text-weight-semibold"
                    >
                        Subscribe
                    </button>
                </div>
            </div>
        </form>
    </div>
);


export default SubscribeMailingList;
